<script>
    import { section } from "../store/section.js";
    import { token } from "../store/token.js";
    import { refresh } from "../store/refresh.js";
    import { active_workspace } from "../store/workspace.js";
    import { workspace_list } from "../store/workspace_list.js";

    import { fetch_workspace_list } from "../api/request.js";

    import HeadingContent from "./component/HeadingContent.svelte";

    export let check_error;

    const set_section = (selected_section) => {
        section.set(selected_section);
    };

    let local_workspace_list;

    const fetch_workspace_list_data = async () => {
        if ($workspace_list.length > 0) {
            return;
        }

        local_workspace_list = await fetch_workspace_list($token);

        workspace_list.set(local_workspace_list);
        console.log($workspace_list);
        refresh.set("0");
    };

    console.log($workspace_list);

    import { fetch_workspace_billing_info } from "../api/request.js";
    import { user } from "../store/user.js";
</script>

<div class="settings-holder settings-active">
    <!-- Settings Workspaces Overview (First Level) (the items of the menu of workspaces)-->
    <div class="settings-holder-content content-active">
        <HeadingContent title="Workspaces" back_button_enabled={false} />
        <!--
        <div class="settings-heading">
            <div class="d-md-none">
                <div class="heading-block">
                    <a class="nav-opener" href="#"
                        ><i class="icon icon-navigation" /></a
                    ><a class="nav-back" href="#">
                        <div class="ico-holder">
                            <i class="icon icon-chevron-left" />
                        </div>
                        <div class="ico-holder">
                            <i class="icon icon-users" />
                        </div>
                        <div class="title-holder">
                            <strong class="settings-title">Workspaces</strong>
                        </div></a
                    >
                </div>
            </div>
            <div class="d-none d-md-block">
                <div class="heading-block">
                    <h1 class="h6 settings-title">Workspaces</h1>
                </div>
            </div>
        </div>
        -->
        <div class="settings-content">
            <div class="settings-content-holder">
                <div class="">
                    <div class="card-settings-main card bg-transparent-mobile">
                        <div class="card-body">
                            <nav>
                                <ul class="nav-second-level nav-settings">
                                    {#await fetch_workspace_list_data()}
                                        <li
                                            on:click={() => {
                                                set_section(
                                                    "account/workspaces/overview",
                                                );
                                            }}
                                        >
                                            <div class="opener-third-level">
                                                <div class="df-row df-aic gx-2">
                                                    <div class="col">
                                                        <div
                                                            class="opener-text"
                                                        >
                                                            <div
                                                                class="df-row df-jcb df-aic"
                                                            >
                                                                <div
                                                                    class="col"
                                                                >
                                                                    <strong
                                                                        class="nav-title"
                                                                        >Loading
                                                                        workspaces</strong
                                                                    >
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    {:then data}
                                        {#each $workspace_list as workspace}
                                            {#if workspace.permission_list.indexOf("administrator") > -1}
                                                <li
                                                    on:click={() => {
                                                        set_section(
                                                            "account/workspaces/overview",
                                                        );
                                                    }}
                                                >
                                                    <a
                                                        class="opener-third-level"
                                                        href="#"
                                                        on:click={() => {
                                                            active_workspace.set(
                                                                workspace,
                                                            );
                                                            set_section(
                                                                "account/workspaces/overview",
                                                            );
                                                        }}
                                                    >
                                                        <div
                                                            class="df-row df-aic gx-2"
                                                        >
                                                            <div
                                                                class="col-auto"
                                                            >
                                                                <span
                                                                    class="ico-holder"
                                                                >
                                                                    {#if workspace.image_url}
                                                                        <img
                                                                            src={workspace.image_url}
                                                                            loading="lazy"
                                                                            alt=""
                                                                            width="28"
                                                                            height="28"
                                                                            class="workspace-avatar"
                                                                        />
                                                                    {:else}
                                                                        <img
                                                                            src="https://dvr722unfp578.cloudfront.net/image/workspace_image/c5bca08aed57d9d634b8e1541cb0140a44a64d213eb8acd183ef1249272daa53.jpg"
                                                                            loading="lazy"
                                                                            alt=""
                                                                            width="28"
                                                                            height="28"
                                                                        />
                                                                        <svg
                                                                            fill="#3F6078"
                                                                            width="28"
                                                                            height="28"
                                                                            style="position: absolute;"
                                                                        >
                                                                            <clipPath
                                                                                id="squircle"
                                                                                clipPathUnits="objectBoundingBox"
                                                                            >
                                                                                <path
                                                                                    d="M0,0.5 C0,0.06,0.06,0,0.5,0 C0.94,0,1,0.06,1,0.5 C1,0.94,0.94,1,0.5,1 C0.06,1,0,0.94,0,0.5"
                                                                                />
                                                                            </clipPath>
                                                                        </svg>
                                                                    {/if}
                                                                </span>
                                                            </div>
                                                            <div class="col">
                                                                <div
                                                                    class="opener-text"
                                                                >
                                                                    <div
                                                                        class="df-row df-jcb df-aic"
                                                                    >
                                                                        <div
                                                                            class="col"
                                                                        >
                                                                            <strong
                                                                                class="nav-title"
                                                                                >{workspace.title}</strong
                                                                            >
                                                                            <div
                                                                                class="nav-text"
                                                                            >
                                                                                <p
                                                                                >
                                                                                    {#await fetch_workspace_billing_info(workspace.string_id, $token)}
                                                                                        Loading
                                                                                        subscription
                                                                                        info
                                                                                    {:then billing_info}
                                                                                        Vollume
                                                                                        -
                                                                                        {billing_info
                                                                                            .readable_super_short_title_mapping[
                                                                                            billing_info
                                                                                                .plan_id
                                                                                        ]}
                                                                                        Subscription
                                                                                    {:catch error}
                                                                                        Failed
                                                                                        to
                                                                                        load
                                                                                        subscription
                                                                                        info
                                                                                        {check_error(error)}
                                                                                    {/await}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div
                                                                            class="col-auto"
                                                                        >
                                                                            <i
                                                                                class="icon icon-chevron-right"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div></a
                                                    >
                                                </li>
                                            {/if}
                                        {/each}
                                    {:catch error}
                                        {error}
                                        <p>Failed to load the list.</p>
                                    {/await}
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
                <div class="">
                    <div class="card-settings-main card bg-transparent-mobile">
                        <div class="card-body">
                            <nav>
                                <ul class="nav-second-level nav-settings">
                                    <li style="margin-top:20px">
                                        <div class="df-row df-aic gx-2">
                                            <div class="col-auto">
                                                <h6>Guest workspaces</h6>
                                            </div>
                                        </div>
                                    </li>

                                    {#each $workspace_list as workspace}
                                        {#if workspace.permission_list.indexOf("administrator") == -1}
                                            <li style="padding:10px">
                                                <div class="df-row df-aic gx-2">
                                                    <div class="col-auto">
                                                        <span
                                                            class="ico-holder"
                                                        >
                                                            {#if workspace.image_url}
                                                                <img
                                                                    src={workspace.image_url}
                                                                    loading="lazy"
                                                                    alt=""
                                                                    width="28"
                                                                    height="28"
                                                                    class="workspace-avatar"
                                                                />
                                                            {:else}
                                                                <img
                                                                    src="https://dvr722unfp578.cloudfront.net/image/workspace_image/c5bca08aed57d9d634b8e1541cb0140a44a64d213eb8acd183ef1249272daa53.jpg"
                                                                    loading="lazy"
                                                                    alt=""
                                                                    width="28"
                                                                    height="28"
                                                                    class="workspace-avatar"
                                                                />
                                                            {/if}
                                                        </span>
                                                    </div>
                                                    <div class="col">
                                                        <div
                                                            class="opener-text"
                                                        >
                                                            <div
                                                                class="df-row df-jcb df-aic"
                                                            >
                                                                <div
                                                                    class="col"
                                                                >
                                                                    <strong
                                                                        class="nav-title"
                                                                        >{workspace.title}</strong
                                                                    >
                                                                    <div
                                                                        class="nav-text"
                                                                    >
                                                                        <p>
                                                                            Your
                                                                            role:
                                                                            {workspace
                                                                                .role_list[0]
                                                                                .role_name}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        {/if}
                                    {/each}

                                    <!--<li
                                        on:click={() => {
                                            set_section(
                                                "account/workspaces/overview"
                                            );
                                        }}
                                    >
                                        <a class="opener-third-level" href="#">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col-auto">
                                                    <span class="ico-holder"
                                                        ><img
                                                            src="../account/images/avatar-vollume.png"
                                                            alt="vollume"
                                                            width="28"
                                                            height="28"
                                                        /></span
                                                    >
                                                </div>
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >Avery
                                                                    Goodsong’s
                                                                    Workspace</strong
                                                                >
                                                                <div
                                                                    class="nav-text"
                                                                >
                                                                    <p>
                                                                        Vollume
                                                                        -
                                                                        Starter
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="col-auto"
                                                            >
                                                                <i
                                                                    class="icon icon-chevron-right"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div></a
                                        >
                                    </li>
                                    <li
                                        on:click={() => {
                                            set_section(
                                                "account/workspaces/overview"
                                            );
                                        }}
                                    >
                                        <a class="opener-third-level" href="#">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col-auto">
                                                    <span class="ico-holder"
                                                        ><img
                                                            src="../account/images/avatar-riot-games.png"
                                                            alt="riot-games"
                                                            width="28"
                                                            height="28"
                                                        /></span
                                                    >
                                                </div>
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >Riot Games
                                                                    Workspace</strong
                                                                >
                                                                <div
                                                                    class="nav-text"
                                                                >
                                                                    <p>
                                                                        Vollume
                                                                        - Team
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="col-auto"
                                                            >
                                                                <i
                                                                    class="icon icon-chevron-right"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div></a
                                        >
                                    </li>
                                    <li
                                        on:click={() => {
                                            set_section(
                                                "account/workspaces/overview"
                                            );
                                        }}
                                    >
                                        <a class="opener-third-level" href="#">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col-auto">
                                                    <span class="ico-holder"
                                                        ><img
                                                            src="../account/images/avatar-pulse-music-group.png"
                                                            alt="pulse music group"
                                                            width="28"
                                                            height="28"
                                                        /></span
                                                    >
                                                </div>
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >Pulse
                                                                    Recording
                                                                    Workspace</strong
                                                                >
                                                                <div
                                                                    class="nav-text"
                                                                >
                                                                    <p>
                                                                        Vollume
                                                                        -
                                                                        Enterprise
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="col-auto"
                                                            >
                                                                <i
                                                                    class="icon icon-chevron-right"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div></a
                                        >
                                    </li>
                                    -->
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
                <div
                    class="card-settings-main-footer card bg-transparent-mobile"
                >
                    <div class="card-body">
                        <div class="df-row df-aic gx-1">
                            <div class="col">
                                <div class="d-none d-md-block">
                                    <p>
                                        Invite members to collaborate on
                                        projects &amp; playlists.
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-auto">
                                <a
                                    class="btn btn-primary"
                                    href="#"
                                    on:click={() => {
                                        set_section(
                                            "account/workspaces/create_subscribe",
                                        );
                                    }}>Create New Workspace</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Settings Workspaces Overview (Second Level) (Avery-Goodsong)-->
    <div class="settings-holder-content">
        <div class="settings-heading">
            <div class="heading-block">
                <a class="nav-opener" href="#"
                    ><i class="icon icon-navigation" /></a
                ><a class="nav-back" href="#">
                    <div class="ico-holder">
                        <i class="icon icon-chevron-left" />
                    </div>
                    <div class="title-holder">
                        <strong class="settings-title"
                            >Avery Goodsong’s Workspace</strong
                        >
                    </div></a
                >
            </div>
        </div>
        <div class="settings-content">
            <div class="settings-content-holder">
                <div class="card-h-100">
                    <div class="card-evary-goods card-join-bottom card">
                        <div class="card-body">
                            <div class="card-block">
                                <div class="df-row df-aic gx-05">
                                    <div class="col-auto">
                                        <div class="logo-holder">
                                            <img
                                                src="images/avatar-vollume-2.png"
                                                alt="vollume"
                                                width="48"
                                                height="48"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        <div class="card-box">
                                            <div class="card-box-body">
                                                <h3 class="h6 box-title">
                                                    Vollume - Starter
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-block">
                                <strong class="price-workspace text-white"
                                    >$0.00 Per year.<span class="fw-normal"
                                        >Forever</span
                                    ></strong
                                >
                                <p>
                                    Your Vollume starter plan is free, forever
                                </p>
                                <p>
                                    <a href="#"
                                        >See available plans &amp; add-ons</a
                                    >
                                </p>
                            </div>
                            <div class="card-block">
                                <div class="card-row df-row df-jcsb gx-1">
                                    <div class="col">
                                        <span class="seats-workspace"
                                            >Seats used <span
                                                class="seats-workspace__used"
                                                >1</span
                                            >
                                            of
                                            <span class="seats-workspace__total"
                                                >2</span
                                            ></span
                                        >
                                    </div>
                                    <div class="col-auto">
                                        <a class="link-sm-blue" href="#"
                                            >Manage Seats</a
                                        >
                                    </div>
                                </div>
                                <div class="card-row df-row df-jcsb gx-1">
                                    <div class="col">
                                        <span class="storage-workspace"
                                            >Storage — <span
                                                class="storage-workspace__availible"
                                                >20</span
                                            > songs</span
                                        >
                                    </div>
                                    <div class="col-auto">
                                        <a class="link-sm-blue" href="#"
                                            >Manage Storage</a
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="card-settings-main-footer card bg-transparent-mobile"
                >
                    <div class="card-body">
                        <div class="df-row df-aic row-mobile-reverse gx-1">
                            <div class="col">
                                <p>
                                    Upgrade to Professional, Team or Enterprise
                                    for even more great features.
                                </p>
                            </div>
                            <div class="col-md-auto">
                                <a class="btn btn-primary" href="#"
                                    >Upgrade Plan</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Settings Workspaces Overview (Third Level) (Avery-Goodsong Storage)-->
    <div class="settings-holder-content">
        <div class="settings-heading">
            <div class="heading-block">
                <a class="nav-opener" href="#"
                    ><i class="icon icon-navigation" /></a
                ><a class="nav-back" href="#">
                    <div class="ico-holder">
                        <i class="icon icon-chevron-left" />
                    </div>
                    <div class="title-holder">
                        <strong class="settings-title"
                            ><span class="add-title fw-normal">Storage:</span
                            >Avery Goodsong’s Workspace</strong
                        >
                    </div></a
                >
            </div>
        </div>
        <div class="settings-content">
            <div class="settings-content-holder">
                <div class="card-h-100">
                    <div class="card-workspace-storage card">
                        <div class="card-body">
                            <h4 class="h5 card-title fw-normal">
                                Available <span
                                    class="songs-available text-white">8</span
                                > <span class="text-white">songs</span> of
                                <span class="songs-total">20</span> songs
                            </h4>
                            <div
                                class="progress-storage-container storage-number"
                            >
                                <div
                                    class="progress-storage progress-storage-number"
                                >
                                    <div
                                        class="progress-bar__your"
                                        style="width: 25%;"
                                    />
                                    <div
                                        class="progress-bar__shared"
                                        style="width: 32%; left: 25%;"
                                    />
                                </div>
                                <ul class="list-storage-description">
                                    <li class="item-your">
                                        Your tracks (<span class="tracks-your"
                                            >5</span
                                        > songs)
                                    </li>
                                    <li class="item-shared">
                                        Shared tracks (<span
                                            class="tracks-shared">7</span
                                        > songs)
                                    </li>
                                    <li class="item-unused">
                                        Unused Storage (<span
                                            class="tracks-unused">8</span
                                        > songs)
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <span class="subtitle text-white text-uppercase"
                        >Your storage after upgrade:</span
                    >
                    <div class="card-storage-usings card bg-transparent">
                        <div class="card-body">
                            <h4 class="h5 card-title fw-normal">
                                Using <span class="storage-used text-gray-light"
                                    >16 GB</span
                                >
                                of <span class="storage-total">250 GB</span>
                            </h4>
                            <div
                                class="progress-storage-container storage-value"
                            >
                                <div
                                    class="progress-storage progress-storage-value"
                                >
                                    <div
                                        class="progress-bar__your"
                                        style="width: 25%;"
                                    />
                                    <div
                                        class="progress-bar__shared"
                                        style="width: 32%; left: 25%;"
                                    />
                                </div>
                                <ul class="list-storage-description">
                                    <li class="item-your">
                                        Your tracks (<span class="tracks-your"
                                            >0.65</span
                                        >) GB
                                    </li>
                                    <li class="item-shared">
                                        Shared tracks (<span
                                            class="tracks-shared">1.02</span
                                        >) GB
                                    </li>
                                    <li class="item-unused">
                                        Unused Storage (<span
                                            class="tracks-unused">248.33</span
                                        >) GB
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="card-settings-main-footer card bg-transparent-mobile"
                >
                    <div class="card-body">
                        <div class="df-row df-aic row-mobile-reverse gx-1">
                            <div class="col">
                                <p>
                                    Upgrade to Professional, Team or Enterprise
                                    for even more great features.
                                </p>
                            </div>
                            <div class="col-md-auto">
                                <a class="btn btn-primary" href="#"
                                    >Upgrade Plan</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Settings Workspaces Overview (Second Level) (Riot Games)-->
    <div class="settings-holder-content">
        <div class="settings-heading">
            <div class="heading-block">
                <a class="nav-opener" href="#"
                    ><i class="icon icon-navigation" /></a
                ><a class="nav-back" href="#">
                    <div class="ico-holder">
                        <i class="icon icon-chevron-left" />
                    </div>
                    <div class="title-holder">
                        <strong class="settings-title"
                            >Avery Goodsong’s Workspace</strong
                        >
                    </div></a
                >
            </div>
        </div>
        <div class="settings-content">
            <div class="settings-content-holder">
                <div class="card-h-100">
                    <div class="card-evary-goods card-join-bottom card">
                        <div class="card-body">
                            <div class="card-block">
                                <div class="df-row df-aic gx-05">
                                    <div class="col-auto">
                                        <div class="logo-holder">
                                            <img
                                                src="images/avatar-riot-games-square.png"
                                                alt="vollume"
                                                width="48"
                                                height="48"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        <div class="card-box">
                                            <div class="card-box-body">
                                                <h3 class="h6 box-title">
                                                    Vollume - Team
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-block">
                                <strong class="price-workspace text-white"
                                    >$119.99 Per year.<span
                                        class="fw-normal d-block"
                                        >Renews on
                                        <time datetime="2022-07-23"
                                            >July 23, 2022</time
                                        ></span
                                    ></strong
                                >
                                <p>
                                    You’re a member of the Vollume - Riot Games
                                    Team Workspace. Asset Containers, public
                                    presentations, offline playback , and 250 GB
                                    storage.
                                </p>
                                <p>
                                    <a href="#"
                                        >See available plans &amp; add-ons</a
                                    >
                                </p>
                            </div>
                            <div class="card-block">
                                <div class="card-row df-row df-jcsb gx-1">
                                    <div class="col">
                                        <span class="seats-workspace"
                                            >Seats used <span
                                                class="seats-workspace__used"
                                                >1</span
                                            >
                                            of
                                            <span class="seats-workspace__total"
                                                >2</span
                                            ></span
                                        >
                                    </div>
                                    <div class="col-auto">
                                        <a class="link-sm-blue" href="#"
                                            >Manage Seats</a
                                        >
                                    </div>
                                </div>
                                <div class="card-row df-row df-jcsb gx-1">
                                    <div class="col">
                                        <span class="storage-workspace"
                                            >Storage — <span
                                                class="storage-workspace__availible"
                                                >250</span
                                            > GB</span
                                        >
                                    </div>
                                    <div class="col-auto">
                                        <a class="link-sm-blue" href="#"
                                            >Manage Storage</a
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="card-settings-main-footer card bg-transparent-mobile"
                >
                    <div class="card-body">
                        <div class="df-row df-aic df-md-jce gx-1">
                            <div class="col-md-auto">
                                <a class="btn btn-dark" href="#">Change Plan</a>
                            </div>
                            <div class="col-md-auto">
                                <a class="btn btn-danger" href="#"
                                    >Cancel Subscribtion</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Settings Workspaces Overview (Third Level) (Riot Games Storage)-->
    <div class="settings-holder-content">
        <div class="settings-heading">
            <div class="heading-block">
                <a class="nav-opener" href="#"
                    ><i class="icon icon-navigation" /></a
                ><a class="nav-back" href="#">
                    <div class="ico-holder">
                        <i class="icon icon-chevron-left" />
                    </div>
                    <div class="title-holder">
                        <strong class="settings-title"
                            ><span class="add-title fw-normal">Storage:</span
                            >Avery Goodsong’s Workspace</strong
                        >
                    </div></a
                >
            </div>
        </div>
        <div class="settings-content">
            <div class="settings-content-holder">
                <div class="card-h-100">
                    <div class="card-workspace-storage card">
                        <div class="card-body">
                            <h4 class="h5 card-title fw-normal">
                                Using <span class="storage-used text-white"
                                    >145.67</span
                                > <span class="text-white">GB</span> of
                                <span class="storage-total">250</span> GB
                            </h4>
                            <div
                                class="progress-storage-container storage-number"
                            >
                                <div
                                    class="progress-storage progress-storage-number"
                                >
                                    <div
                                        class="progress-bar__your"
                                        style="width: 25%;"
                                    />
                                    <div
                                        class="progress-bar__shared"
                                        style="width: 32%; left: 25%;"
                                    />
                                </div>
                                <ul class="list-storage-description">
                                    <li class="item-your">
                                        Your tracks (<span class="tracks-your"
                                            >56.25</span
                                        >) GB
                                    </li>
                                    <li class="item-shared">
                                        Shared tracks (<span
                                            class="tracks-shared">82.42</span
                                        >) GB
                                    </li>
                                    <li class="item-unused">
                                        Unused Storage (<span
                                            class="tracks-unused">104.33</span
                                        >) GB
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .workspace-avatar {
        /*clip-path: circle(12px at center);*/
        clip-path: polygon(
            13.890123px 0px,
            calc(100% - 13.890123px) 0px,
            calc(100% - 12.431746px) 0.006884px,
            calc(100% - 10.974148px) 0.050545px,
            calc(100% - 9.520666px) 0.164631px,
            calc(100% - 8.079275px) 0.382298px,
            calc(100% - 6.667506px) 0.744337px,
            calc(100% - 5.312369px) 1.278137px,
            calc(100% - 4.049693px) 2.001765px,
            calc(100% - 2.926417px) 2.926417px,
            calc(100% - 2.001765px) 4.049693px,
            calc(100% - 1.278137px) 5.312369px,
            calc(100% - 0.744337px) 6.667506px,
            calc(100% - 0.382298px) 8.079275px,
            calc(100% - 0.164631px) 9.520666px,
            calc(100% - 0.050545px) 10.974148px,
            calc(100% - 0.006884px) 12.431746px,
            calc(100% - 0.006884px) calc(100% - 12.431746px),
            calc(100% - 0.050545px) calc(100% - 10.974148px),
            calc(100% - 0.164631px) calc(100% - 9.520666px),
            calc(100% - 0.382298px) calc(100% - 8.079275px),
            calc(100% - 0.744337px) calc(100% - 6.667506px),
            calc(100% - 1.278137px) calc(100% - 5.312369px),
            calc(100% - 2.001765px) calc(100% - 4.049693px),
            calc(100% - 2.926417px) calc(100% - 2.926417px),
            calc(100% - 4.049693px) calc(100% - 2.001765px),
            calc(100% - 5.312369px) calc(100% - 1.278137px),
            calc(100% - 6.667506px) calc(100% - 0.744337px),
            calc(100% - 8.079275px) calc(100% - 0.382298px),
            calc(100% - 9.520666px) calc(100% - 0.164631px),
            calc(100% - 10.974148px) calc(100% - 0.050545px),
            calc(100% - 12.431746px) calc(100% - 0.006884px),
            calc(100% - 13.890123px) 100%,
            13.890123px 100%,
            12.431746px calc(100% - 0.006884px),
            10.974148px calc(100% - 0.050545px),
            9.520666px calc(100% - 0.164631px),
            8.079275px calc(100% - 0.382298px),
            6.667506px calc(100% - 0.744337px),
            5.312369px calc(100% - 1.278137px),
            4.049693px calc(100% - 2.001765px),
            2.926417px calc(100% - 2.926417px),
            2.001765px calc(100% - 4.049693px),
            1.278137px calc(100% - 5.312369px),
            0.744337px calc(100% - 6.667506px),
            0.382298px calc(100% - 8.079275px),
            0.164631px calc(100% - 9.520666px),
            0.050545px calc(100% - 10.974148px),
            0.006884px calc(100% - 12.431746px),
            0.006884px 12.431746px,
            0.050545px 10.974148px,
            0.164631px 9.520666px,
            0.382298px 8.079275px,
            0.744337px 6.667506px,
            1.278137px 5.312369px,
            2.001765px 4.049693px,
            2.926417px 2.926417px,
            4.049693px 2.001765px,
            5.312369px 1.278137px,
            6.667506px 0.744337px,
            8.079275px 0.382298px,
            9.520666px 0.164631px,
            10.974148px 0.050545px,
            12.431746px 0.006884px,
            13.890123px 0px
        );

        fill: #fff;
    }
</style>
